import { render } from "./AChip.vue?vue&type=template&id=2a35d0ad"
import script from "./AChip.vue?vue&type=script&lang=js"
export * from "./AChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__